import { BridgeProvider } from '../../domain/flow'

export const RANGO_ENABLED = false as boolean

export interface ProviderRouteConfig {
  bridgeOutputToken: 'TON' | 'USDT'
  etaHint: string
  etaHintDelayed?: string
  delayThresholdSec?: number
  txCount: number
  extraTxIfJupiter?: number
}

export const PROVIDER_ROUTE_CONFIG: Record<BridgeProvider, ProviderRouteConfig> = {
  [BridgeProvider.RANGO]: {
    bridgeOutputToken: 'TON',
    etaHint: 'Cross-chain bridge may take up to 20 min',
    txCount: 2,
  },
  [BridgeProvider.SYMBIOSIS]: {
    bridgeOutputToken: 'USDT',
    etaHint: 'Cross-chain bridge may take 2-5 min',
    etaHintDelayed: 'Taking longer than usual — Symbiosis can take up to 10 min for some routes',
    delayThresholdSec: 60,
    txCount: 2,
  },
  [BridgeProvider.LAYERSWAP]: {
    // Live quotes override this fallback with their probed output token.
    bridgeOutputToken: 'TON',
    etaHint: 'Bridge via Layerswap (~15 sec)',
    etaHintDelayed: 'Taking longer than usual, please wait...',
    delayThresholdSec: 60,
    txCount: 2,
    extraTxIfJupiter: 1,
  },
}

export const COMPOSITE_ROUTE_CONFIG: ProviderRouteConfig = {
  bridgeOutputToken: 'USDT',
  etaHint: 'Multi-hop route via Layerswap + Symbiosis (~5-20 min)',
  etaHintDelayed: 'Taking longer than usual, please wait...',
  delayThresholdSec: 120,
  txCount: 4,
}
